import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'bg',
    fullName: 'Bulgarian',
    nativeName: 'Български',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Идва нещо невероятно",
    landing_subtitle: "ArgVoid е студио за разработка на приложения и игри. Очаквайте нови неща скоро!",
    select_language: "Изберете език",
    search_placeholder: "Търсене на езици...",
    terms_title: "Условия за ползване",
    policy_title: "Политика за поверителност",
    cookies_title: "Политика за бисквитки",
    terms_content: `
        <strong>1. Приемане на Условията </strong><br>
        С достъпа до ArgVoid тези Условия за ползване се приемат. Ако тези условия не са съгласни, услугата не трябва да се използва.<br><br>

        <strong>2. Използване на платформата </strong><br>
        ArgVoid и неговите приложения се предоставят „както е“ за информационни и творчески цели. Услугата трябва да се използва само за законни цели.<br><br>

        <strong>3. Забранено поведение </strong><br>
        Използването на уязвимостите на сайта, спамът или опитът за неоторизиран достъп до инфраструктурата са строго забранени.<br><br>

        <strong>4. Отказ от отговорност </strong><br>
        Платформата и услугите могат да бъдат променяни по всяко време без предизвестие. Не се предоставя гаранция относно продължителността на работа или наличността на услугата.
    `,
    policy_content: `
        <strong>1. Събиране на информация </strong><br>
        В момента платформата не изисква удостоверяване на потребителя или създаване на акаунт. От посетителите не се събира активно лична идентифицираща информация (като имена или имейл адреси). <br><br>

        <strong>2. Данни за използване </strong><br>
        Могат да се събират основни, анонимизирани анализи, за да се разбере трафикът на сайта и да се подобрят приложенията. Тези данни не са свързани с индивидуални самоличности на потребители.<br><br>

        <strong>3. Услуги на трети страни </strong><br>
        Доставчици на трети страни могат да бъдат използвани за хостинг и аналитични услуги. Практиките за поверителност на тези съответни доставчици управляват анонимните данни, обработвани в тяхната инфраструктура. <br><br>

        <strong>4. Сигурност на данните </strong><br>
        За защита на платформата се прилагат разумни мерки за сигурност. Никой метод за предаване през интернет обаче не е напълно сигурен.<br><br>
    `,
    cookies_content: `
        <strong>1. Какво представляват бисквитките и локалното съхранение? </strong><br>
        Бисквитките и локалното хранилище на браузъра са малки файлове с данни, съхранявани на устройството, за да запомнят предпочитанията за конфигурация при посещения. <br><br>

        <strong>2. Цел на употреба </strong><br>
        Browser LocalStorage се използва стриктно за запазване на конфигурационните настройки, като например: <br>
        - Езикови предпочитания <br>
        - Конфигурация на потребителския интерфейс (напр. настройки за оформление или тема) <br>
        - Кеш за временно приложение <br><br>

        <strong>3. Без проследяване </strong><br>
        Бисквитките и локалното хранилище не се използват за рекламни цели или за проследяване от трети страни. Всички съхранени данни са строго за основната функционалност на платформата.<br><br>

        <strong>4. Control</strong><br>
        Данните на браузъра могат да бъдат изчистени по всяко време чрез настройките на браузъра, което ще нулира всички локални конфигурации.
    `,
    cookie_consent_text: "Ние използваме основни бисквитки, за да гарантираме правилното функциониране на уебсайта, като например поддържане на вашата сесия активна, запазване на вашите езикови предпочитания и други персонализирани конфигурации.",
    read_policy: "Прочетете Политиката за бисквитки",
    support_title: "Свържете се с поддръжката",
    support_subject_label: "Предмет",
    support_message_label: "Съобщение",
    support_submit_button: "Изпратете съобщение",
    support_hint: "Забележка: Това ще отвори вашето приложение за имейл по подразбиране, за да изпратите съобщението.",
    support_success_msg: "Отваряне на вашето имейл приложение...",
    support_error_msg: "Неуспешно изпращане на съобщение. Моля, опитайте отново по-късно.",
    explorer_title: "Изследовател",
    history_title: "История",
    animation_title: "Анимация",
    config_title: "Конфигурация",
    tool_mouse: "Изберете (Ctrl+M)",
    tool_brush: "Четка (Ctrl+B)",
    tool_brush_mode: "Режим на превключване (плътно/чисто)",
    tool_eraser: "Гума (Ctrl+E)",
    tool_brush_size: "Регулирайте размера на четката",
    tool_bucket: "Запълване (Ctrl+F)",
    tool_eyedropper: "Пипетка за очи",
    tool_grid: "Решетка (Ctrl+Shift+B)",
    tool_rotate: "Завъртане (Ctrl+Shift+R)",
    tool_flip_h: "Обърнете H (Ctrl+Shift+H)",
    tool_flip_v: "Обърнете V (Ctrl+Shift+V)",
    tool_transpose: "Транспониране (Ctrl+Shift+T)",
    label_width: "ширина",
    label_height: "Височина",
    label_frames: "Брой рамки",
    label_animation: "Стил на анимация",
    label_background_color: "Цвят на фона",
    label_interval: "Интервал",
    tool_anim_config: "Конфигурация на анимация",
    label_new_width: "Нова ширина",
    label_new_height: "Нова височина",
    label_apply: "Кандидатствайте",
    label_colors: "Цветове",
    label_size: "Размер",
    label_tolerance: "Толерантност",
    val_horizontal: "Хоризонтална",
    val_vertical: "Вертикална",
    val_sequence: "Последователност",
    val_bounce: "Подскачане",
    val_random: "Случаен",
    val_solid: "Твърди",
    val_clear: "ясно",
    action_add_sheet: "Нов лист",
    action_import: "Импортиране",
    action_export: "Експортиране",
    action_sort_projects: "Сортиране",
    sort_date_old: "Първо най-старите",
    sort_date_new: "Първо най-новите",
    sort_name_az: "Име (A-Z)",
    sort_name_za: "Име (Я-А)",
    action_new_sprite: "Нов спрайт",
    action_new_project: "Нов проект",
    modal_save_all_title: "Запазване на всички промени",
    modal_save_all_desc: "Изберете активите за запазване:",
    modal_save_selected: "Запазване на избраното",
    action_saved: "Запазено",
    modal_create_sprite_title: "Създайте нов спрайт",
    modal_create_project_title: "Създаване на нов проект",
    modal_add_sheet_title: "Добавяне на нов лист",
    modal_rename_sheet_title: "Преименуване на лист",
    modal_rename_sprite_title: "Преименуване на Sprite",
    modal_delete_sprite_title: "Изтриване на Sprite",
    modal_delete_project_title: "Изтриване на проекта",
    modal_delete_sheet_title: "Изтриване на лист",
    placeholder_sprite_name: "Име",
    placeholder_project_name: "Име",
    placeholder_sheet_name: "Име",
    placeholder_new_name: "Ново име",
    action_create: "Създавайте",
    action_add: "Добавете",
    action_rename: "Преименуване",
    action_duplicate: "Дубликат",
    action_delete: "Изтриване",
    action_cancel: "Отказ",
    confirm_delete_sprite: "Сигурни ли сте, че искате да изтриете този спрайт?",
    confirm_delete_project: "Сигурни ли сте, че искате да изтриете този проект? Всички спрайтове ще бъдат премахнати.",
    confirm_delete_sheet: "Сигурни ли сте, че искате да изтриете този лист?",
    err_select_sprite: "Моля, първо изберете спрайт.",
    err_select_project: "Моля, първо изберете проект.",
    err_name_empty: "Името не може да бъде празно.",
    err_sprite_exists: "Вече съществува спрайт с това име.",
    err_project_exists: "Проект с това име вече съществува.",
    err_no_content: "Няма съдържание за запазване.",
    err_no_changes: "Няма промени за запазване.",
    err_delete_last_sheet: "Не може да се изтрие последният лист.",
    err_extract_frames: "Не може да се извлекат никакви рамки.",
    err_indexeddb: "Неуспешно запазване локално. Вашият браузър може да не поддържа IndexedDB.",
    msg_upload_success: "Качването е успешно: {0}",
    msg_upload_failed: "Неуспешно качване: {0}",
    msg_save_success: "Запазването е успешно.",
    msg_saving: "Запазва се...",
    msg_multi_save_result: "Запазени {0} актива. {1} грешки.",
    menu_title: "Меню",
    menu_save: "Запазване",
    menu_save_all: "Запазване на всички",
    menu_support: "Свържете се с поддръжката",
    label_local_storage: "Локално съхранение",
    label_sign_in: "Вход",
    modal_export_title: "Експортиране на спрайт",
    label_filename: "Име на файл",
    label_format: "формат",
    action_export_confirm: "Експортиране",
};

export default translations;
